export default {
    title: 'Sucesso',
    text: 'Operação realizada com sucesso',
    color: 'success'
}